// extracted by mini-css-extract-plugin
export default {"editGradeTitle":"EditGradePopup_editGradeTitle__sWkX3","editGradeBody":"EditGradePopup_editGradeBody__TPrwh","editGradeActions":"EditGradePopup_editGradeActions__jo0BM"};